import { overlay } from 'overlay-kit';
import { type OpenPlanStartModalProps } from '@/module/plan/types';
import { isInLtiContext } from '@/shared/lti';
import { PlanStartModal } from './PlanStartModal';
export const openPlanStartModal = (props: OpenPlanStartModalProps) => {
  if (props.planType === 'FREE' || isInLtiContext()) return;
  // 모달 표시
  // 참고: shouldShowModal 체크는 NotifyPlanStartContainer에서 수행됨
  overlay.open(({
    unmount
  }) => <PlanStartModal {...props} onClose={unmount} />);
};